export const INSEE_CODE = '8610Z';
export const EJ_CODE = 'EJ';

export const ENS_EMAIL_DOMAIN = 'patient.mssante.fr';

export const AGE_OF_MAJORITY = 18;

export const NIR_LENGTH = 15; // FR: NIR = 15 digits
